import { type PersonType, personTypeFields } from './personType';

export interface Person {
  id: string;
  idnumber: string;
  ticketnumber: string;
  firstname: string;
  lastname: string;
  cellphone?: string;
  cellConfirmed?: boolean;
  structure?: string;
  regTime?: Date;
  voteRegistered: boolean;
  personType: PersonType;
}

export const personFields = `
  id
  idnumber
  ticketnumber
  firstname
  lastname
  cellphone
  cellConfirmed
  structure
  regTime
  voteRegistered
  personType {
    ${personTypeFields}
  }
`;

export interface PersonInput {
  congressId: number;
  idnumber: string;
  ticketnumber: string;
  firstname: string;
  lastname: string;
  cellphone?: string;
  structure?: string;
  personTypeId: number;
}
export const personInputFieldNames = [
  'congressId',
  'idnumber',
  'ticketnumber',
  'firstname',
  'lastname',
  'cellphone',
  'structure',
  'personTypeId',
] as const;
